import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {DownArrow} from '@components/common/controls/down-arrow'
import {IconOkay} from '@components/common/controls/icon-okay'
import {Dropdown} from '@components/common/dropdown/dropdown'
import {cn} from '@containers/html-utils'
import {useUserCardStore} from './user-card-store'

export const UserCardDepartments = observer(() => {
  const [state, store] = useUserCardStore()

  return (
    <div className="prj-invite__participate">
      <div className="prj-invite__participate-title">
        {Lang.msg.permission.participateDepartments}:
      </div>
      <div className="prj-invite__participate-header">
        <div className="prj-invite__participate-header-proj">
          {Lang.msg.permission.headerDep}
        </div>
        <div className="prj-invite__participate-header-role">
          {Lang.msg.permission.headerDepRole}
        </div>
      </div>

      <div className="prj-invite__participate-list">
        {state.departments.map(dep => (
          <div className="prj-invite__participate-item" key={dep.id}>
            <label className="prj-users-ch">
              <input
                type="checkbox"
                className="_checkbox"
                checked={!!state.chosenDepartments[dep.id]}
                onChange={() => store.toggleDep(dep.id)}
              />
              <span className="_checkbox" />
              <span className="prj-invite__item-text">{dep.title}</span>
            </label>

            {state.chosenDepartments[dep.id] && (
              <div className="prj-invite-role">
                <Dropdown
                  hideArrow
                  content={
                    <div
                      className="prj-invite-role__menu"
                      onMouseDown={e => e.stopPropagation()}
                    >
                      <div
                        className={cn(
                          'prj-invite-role__option',
                          state.chosenDepartments[dep.id] === 'manager' &&
                            'prj-invite-role__option--current'
                        )}
                        onClick={() => {
                          store.chooseDepRole(dep.id, 'manager')
                          store.toggleDepMenu(undefined)
                        }}
                      >
                        <IconOkay />
                        {Lang.msg.permission.depManager}
                      </div>
                      <div
                        className={cn(
                          'prj-invite-role__option',
                          state.chosenDepartments[dep.id] === 'member' &&
                            'prj-invite-role__option--current'
                        )}
                        onClick={() => {
                          store.chooseDepRole(dep.id, 'member')
                          store.toggleDepMenu(undefined)
                        }}
                      >
                        <IconOkay />
                        {Lang.msg.permission.depMember}
                      </div>
                    </div>
                  }
                  visible={state.menuOpenForDepartmentId === dep.id}
                  onVisibleChange={() => store.toggleDepMenu(undefined)}
                >
                  <div
                    className="prj-invite-role__name"
                    onClick={e => store.toggleDepMenu(dep.id, e)}
                  >
                    {state.chosenDepartments[dep.id] === 'manager'
                      ? Lang.msg.permission.depManager
                      : Lang.msg.permission.depMember}
                    <DownArrow />
                  </div>
                </Dropdown>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
})
